import { routerReducer } from '@ngrx/router-store';
import { Action, ActionReducerMap } from '@ngrx/store';
import { userSettingsReducer } from './user-settings.reducer';
import { AppState } from '../models';

export const reducers: ActionReducerMap<AppState, Action> = {
	userSettingsState: userSettingsReducer,
	routerState: routerReducer,
};
